import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaContabilidad } from '../_contabilidad.js';

/**
 * La vista a la que llega la contadora al entrar. Misma razón que en
 * `_operacion/inicio.tsx`: el grupo no tiene `path`, así que la dirección del grupo no
 * existe hasta que un hijo la declara.
 *
 * Ojo con la dirección: es `/contabilidad` a secas. La fase 5 cuelga de este mismo grupo
 * `/contabilidad/gasto` y `/contabilidad/conciliacion`, que son hermanas y no hijas.
 */
export const rutaInicioContabilidad = createRoute({
  getParentRoute: () => rutaContabilidad,
  path: '/contabilidad',
  component: lazyRouteComponent(() => import('./pantalla-inicio.js'), 'InicioContabilidad'),
});
